import { getInstallation } from "../services/Api";
import { eventTracker } from "../services/tracker";

export default {
  state: {
    isFetching: false,
    installation: null,
  },
  mutations: {
    setInstallation(state, installation) {
      state.installation = installation;
    },
    setIsFetching(state, bool) {
      state.fetching = bool;
    },
  },
  actions: {
    async fetchInstallation(context, id) {
      context.commit("setIsFetching", true);
      const installation = await getInstallation(id);
      eventTracker.installationId = id;
      context.commit("setInstallation", {
        id: installation.backofficeConfigId,
        hostId: installation.hostId,
      });
      context.commit("setIsFetching", false);
    },
  },
  getters: {
    isInstallationFetching(state) {
      return state.isFetching;
    },
    installation(state) {
      return state.installation;
    },
  },
};
